module.exports = __webpack_public_path__ + "img/SWP_Hammer_2H_01.786e5c09.png";